/**
 * Сериализует данные для Laravel GET запросов
 * @param obj Объект для сериализации
 * @param prefix Префикс для ключей (используется для рекурсии)
 * @returns Плоский объект с ключами в формате Laravel
 */
export function serializeForLaravel(obj: any, prefix = ''): Record<string, any> {
    const result: Record<string, any> = {};

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            const newKey = prefix ? `${prefix}[${key}]` : key;

            if (value === null || value === undefined) {
                result[newKey] = '';
            } else if (Array.isArray(value)) {
                // Обработка массивов
                value.forEach((item, index) => {
                    if (typeof item === 'object' && item !== null) {
                        // Массив объектов
                        Object.assign(result, serializeForLaravel(item, `${newKey}[${index}]`));
                    } else {
                        // Массив примитивов
                        result[`${newKey}[${index}]`] = item;
                    }
                });
            } else if (typeof value === 'object' && value !== null) {
                // Вложенные объекты
                Object.assign(result, serializeForLaravel(value, newKey));
            } else {
                // Примитивные значения
                result[newKey] = value;
            }
        }
    }

    return result;
}
